import Vue from "vue";
import lang from 'element-ui/lib/locale/lang/vi'
import locale from 'element-ui/lib/locale'
import ElementUI from 'element-ui'

import '../css/index.css';

Vue.use(ElementUI, { locale });
locale.use(lang);

